import React, { useState } from 'react';
import { Button, Modal, Form, Switch, InputNumber, Descriptions, message } from 'antd';
import { CloudServerOutlined } from '@ant-design/icons';
import hostSharedAdminService from '../../services/hostSharedAdminService';

const fmtSize = (b) => {
    if (!b) return '0';
    const u = ['B', 'KB', 'MB', 'GB', 'TB'];
    let i = 0;
    let v = b;
    while (v >= 1024 && i < u.length - 1) {
        v /= 1024;
        i++;
    }
    return `${v.toFixed(i ? 1 : 0)} ${u[i]}`;
};

/** 共享主机异地备份(R2)设置:开关 + 保留份数(管理端固定简体中文) */
const OffsiteBackupSettings = () => {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(null);
    const [saving, setSaving] = useState(false);
    const [form] = Form.useForm();

    const show = async () => {
        setOpen(true);
        const res = await hostSharedAdminService.getOffsiteSettings();
        if (res?.success) {
            setData(res.data);
            form.setFieldsValue({ enabled: res.data.enabled, keep: res.data.keep });
        } else {
            message.error(res?.message || res?.error || '加载失败');
        }
    };

    const save = async () => {
        const values = await form.validateFields();
        setSaving(true);
        const res = await hostSharedAdminService.saveOffsiteSettings(values);
        setSaving(false);
        if (res?.success) {
            message.success('已保存');
            setOpen(false);
        } else {
            message.error(res?.message || res?.error || '保存失败');
        }
    };

    const st = data?.stats || {};
    return (
        <>
            <Button icon={<CloudServerOutlined />} onClick={show}>异地备份</Button>
            <Modal open={open} title="异地备份(R2)" onCancel={() => setOpen(false)} onOk={save} confirmLoading={saving} okText="保存">
                <Form form={form} layout="vertical">
                    <Form.Item name="enabled" label="每天自动备份(02:00–06:00 节点时间)" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                    <Form.Item name="keep" label="每个站点保留份数" rules={[{ required: true }]}>
                        <InputNumber min={1} max={data?.max_keep || 60} />
                    </Form.Item>
                </Form>
                {data && (
                    <Descriptions size="small" column={2} bordered>
                        <Descriptions.Item label="站点">{st.sites}</Descriptions.Item>
                        <Descriptions.Item label="备份份数">{st.backups}</Descriptions.Item>
                        <Descriptions.Item label="占用">{fmtSize(st.bytes)}</Descriptions.Item>
                        <Descriptions.Item label="24 小时失败">{st.failed_24h}</Descriptions.Item>
                        <Descriptions.Item label="最近完成" span={2}>{st.last_completed_at || '-'}</Descriptions.Item>
                    </Descriptions>
                )}
            </Modal>
        </>
    );
};

export default OffsiteBackupSettings;
